<style lang="css" scoped>
  a.badge.badge-primary:hover {
    color: white !important;
    background-color: #0069d9!important;
    text-decoration: none;
  }
div.jumbotron.marquee {
  background: #f5f5f5;
}
h1#info-page{
    font-size:45px;
    font-weight:300;
    height:54px;
    line-height:54px;
}
div#user-settings.card.mb-2{
    border: 3px solid #bbbbbb;
    max-width: 69.5rem;
    min-width: 69.5rem;
}
div#danger-settings.card.mb-2{
    border: 1px solid #dc3545;
    max-width: 69.5rem;
    min-width: 69.5rem;
}
hr#topline.my-4 {
    padding-top: 1px;
    margin-bottom: 1rem !important;
    margin-top: 1px !important;
}
.popup-big {
    text-align: center;
    color: #777;
    font-size: .98em;
    font-size:24px;
    font-weight:400;
    color:black;

}

.popup-small {
    text-align: center;
    color: #333;
    font-size:16px;
    font-weight: bold;
}
a#link:hover {
        color: #0056b3 !important;
        text-decoration: none;
}
a#info-link {
    text-align:right;
    color:#6c757c;
    padding-right:4px;
    padding-bottom:2px;
}
a#info-link:hover {
    text-align:right;
    color:#212529 !important;
    padding-right:4px;
    padding-bottom:2px;
}
a.btn-btn-outline-primary:hover {
    color:white !important;
}
</style>

<template>
    <b-container class="bv-example-row">
        <div class="row">
            <div class="col-sm-6">
                <h1 id="info-page">Account Settings</h1>
            </div>
        </div>
        <hr class="my-4" id="topline" style="padding-top: 1px;">
        <template v-if="Object.keys(accessData).length">  
            <div class="row" style="padding: 15px;">
                <b-card
                    title="User"
                    img-top
                    id="user-settings"
                    class="mb-2"
                >
                    <b-card-text>
                        <b-row>
                            <b-col style="font-weight: bold" cols="1">Name</b-col>
                            <b-col cols="3">{{ profile.nickname }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col style="font-weight: bold" cols="1">Email</b-col>
                            <b-col cols="3">{{ profile.email }}</b-col>
                        </b-row>
                    </b-card-text>
                </b-card>
            </div>
            <div class="row" v-if="Object.keys(accessData).length" style="padding: 15px;">
                <b-card
                    title="Account"
                    img-top
                    id="user-settings"
                    class="mb-2"
                >
                    <b-card-text>
                        <b-row>
                            <b-col style="font-weight: bold" cols="3">Plan</b-col>
                            <template v-if='accessData.roles.includes("admin")'>
                                <b-col cols="2">Admin</b-col>
                            </template>
                            <template v-else-if='accessData.roles.includes("enterprise")'>
                                <b-col cols="2">Enterprise</b-col>
                            </template>
                            <template v-else-if='accessData.roles.includes("partner")'>
                                <b-col cols="2">Partner</b-col>
                            </template>
                            <template v-else-if='accessData.roles.includes("pro")'>
                                <b-col cols="2">Pro</b-col>
                            </template>
                            <template v-else-if='accessData.roles.includes("researcher")'>
                                <b-col cols="2">Researcher</b-col>
                            </template>
                            <template v-else-if='accessData.roles.includes("public")'>
                                <b-col cols="2">Public</b-col>
                            </template>
                            <template v-else>
                                <b-col cols="2">Unknown!</b-col>
                            </template>
                        </b-row>
                        <b-row>
                            <b-col style="font-weight: bold" cols="3">Feed Access</b-col>
                            <template v-if='accessData.roles.includes("feed") || accessData.roles.includes("admin") '>
                                <b-col style="color:#28a745" cols="1">Active</b-col>
                                <b-col cols="1">
                                </b-col>
                            </template>
                            <template v-else>
                                <b-col cols="1">Inactive</b-col>
                                <b-col cols="1">
                                    <a id="info-link">
                                        <i id="feed-info" class="fa fa-info-circle"></i>
                                    </a>
                                    <b-tooltip style="max-width: 500px!important;background-color: #fff !important;" triggers="hover" target="feed-info" placement="right">
                                        <div id="dl-tip">
                                            For more information about access to our Malware Feed see our available <b>Plans</b>.
                                        </div>
                                    </b-tooltip>
                                </b-col>
                            </template>
                        </b-row>
                        <b-row v-if="(accessData.month_limit - accessData.month_submissions) > 10">
                            <b-col style="font-weight: bold" cols="3">Remaining Quota</b-col>
                            <b-col cols="8">{{ accessData.month_limit - accessData.month_submissions }}</b-col>
                        </b-row>
                        <b-row v-else-if="(accessData.month_limit - accessData.month_submissions) < 0">
                            <b-col style="font-weight: bold" cols="3">Remaining Quota</b-col>
                            <b-col style="color:red" cols="8">0</b-col>
                        </b-row>
                        <b-row v-else>
                            <b-col style="font-weight: bold" cols="3">Remaining Quota</b-col>
                            <b-col style="color:red" cols="8">{{ accessData.month_limit - accessData.month_submissions }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col style="font-weight: bold" cols="3">Upload Limit (Monthly)</b-col>
                            <b-col cols="8">{{ accessData.month_limit }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col style="font-weight: bold" cols="3">Private Submissions</b-col>
                            <template v-if='accessData.roles.includes("admin") ||
                                            accessData.roles.includes("enterprise") ||
                                            accessData.roles.includes("partner") ||
                                            accessData.roles.includes("pro")'>
                                <b-col style="color:#28a745"cols="2">Enabled</b-col>
                            </template>
                            <template v-else>
                                <b-col cols="2">Disabled</b-col>
                            </template>
                        </b-row>
                    </b-card-text>
                </b-card>
            </div>
            <div v-if="Object.keys(accessData).length" class="row" style="padding: 15px;">
                <b-card
                    title="Plan Management"
                    img-top
                    id="user-settings"
                    class="mb-2"
                >
                    <template v-if='accessData.roles.includes("pro") ||
                                    accessData.roles.includes("researcher")'>
                        <b-card-text>
                            <b-row>
                                <b-col cols="2">
                                    <b-button size="sm" href="/plans" variant="outline-success" style="min-width: 150px;">
                                        Upgrade Plan
                                        &nbsp;
                                        <i class="fa fa-external-link-square" aria-hidden="true"></i>
                                    </b-button>
                                </b-col>
                                <b-col cols="3" style="max-width: 190px;">
                                    <template v-if="!changePaymentLoading">
                                        <b-button id="change-payment" variant="outline-secondary" size="sm" v-on:click="changePayment()" style="min-width: 150px;">
                                            Change Payment
                                            &nbsp;
                                            <i class="fa fa-credit-card-alt" aria-hidden="true"></i>
                                        </b-button>
                                    </template>
                                    <template v-else>
                                        <pulse-loader :loading="changePaymentLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                    </template>
                                    <b-tooltip style="max-width: 500px!important;background-color: #fff !important;" triggers="hover" target="change-payment" placement="top">
                                        <div id="dl-tip">
                                            <b>Warning</b>
                                            <br>
                                            This will cancel your plan. 
                                            <br>
                                            If you do not complete the checkout process with your new payment info your plan will remain cancelled and you will need re-upgrade. 
                                        </div>
                                    </b-tooltip>
                                </b-col>
                                <b-col cols="2"> 
                                    <template v-if="!cancelPlanLoading">
                                        <b-button size="sm" variant="outline-danger" v-on:click="cancelPlan()" style="min-width: 150px;">
                                            Cancel Plan
                                            &nbsp;
                                            <i class="fa fa-ban" aria-hidden="true"></i>
                                        </b-button>
                                    </template>
                                    <template v-else>
                                        <pulse-loader :loading="cancelPlanLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                    </template>
                                </b-col>
                            </b-row>
                        </b-card-text>
                    </template>
                    <template v-else-if='accessData.roles.includes("public")'>
                        <b-card-text>
                            <b-row>
                                <b-col cols="2">
                                    <b-button size="sm" href="/plans" variant="outline-success" style="min-width: 150px;">
                                        Upgrade Plan
                                        &nbsp;
                                        <i class="fa fa-external-link-square" aria-hidden="true"></i>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card-text>
                    </template>
                    <!-- Public and Enterprise accounts cannot manage their plans here -->
                    <template v-else>
                        <b-card-sub-title class="mb-2">
                            Management of your plan must be conducted through your UNPACME account representative. 
                            If you need an account representative please contact us directly. 
                            <br><br>
                        </b-card-sub-title>
                        <b-card-text>
                            <b-button variant="outline-primary" size="sm" target="_blank" href="mailto:unpacme@openanalysis.net" ref="button">
                                Contact Us
                            </b-button>
                        </b-card-text>
                    </template>
                </b-card>
            </div>
            <div v-if='Object.keys(accessData).length && (accessData.roles.includes("feed") || accessData.roles.includes("admin"))' class="row" style="padding: 15px;">
                <b-card
                    title="Sample Feed"
                    img-top
                    id="user-settings"
                    class="mb-2"
                >
                    <b-card-sub-title class="mb-2">
                        Feed metadata access is provided via API.
                        To learn more about the UNPACME API please refer to the <a id="link" target="_blank" href="https://api.unpac.me">API documentation</a>.
                        Feed samples are available via Bulk download.
                        <br><br>
                    </b-card-sub-title>
                    <b-card-text>
                        <b-row>
                            <b-col style="font-size:24px;font-weight:500;">Bulk Download</b-col>
                        </b-row>
                        <b-row>
                            <b-col style="font-weight: bold" cols="3">Feed ULR</b-col>
                            <b-col cols="8">{{ accessData.feed_download_url }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col style="font-weight: bold" cols="3">Feed Username</b-col>
                            <b-col cols="8">{{ accessData.feed_username }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col style="font-weight: bold" cols="3">Feed Password</b-col>
                            <b-col cols="8">{{ accessData.feed_password }}</b-col>
                        </b-row>
                    </b-card-text>
                </b-card>
            </div>
            <div class="row" v-if="Object.keys(accessData).length" style="padding: 15px;">
                <b-card
                    title="API"
                    img-top
                    id="user-settings"
                    class="mb-2"
                >
                    <b-card-text>
                        <b-row>
                            <b-col style="font-weight: bold" cols="2">API Key</b-col>
                            <b-col cols="9">{{ accessData.api_key }}</b-col>
                        </b-row>
                    </b-card-text>
                </b-card>
            </div>
            <div class="row" style="padding: 15px;">
                <b-card
                    title=""
                    img-top
                    id="user-settings"
                    class="mb-2"
                >
                    <b-card-title class="mb-2" 
                                    style='color:rgb(33, 37, 41);
                                    display:block;
                                    font-family:-apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
                                    font-size:24px;
                                    font-weight:500;
                                    height:28px;
                                    line-height:28.8px;
                                    margin-block-end:12px;
                                    margin-block-start:0px;
                                    margin-bottom:12px!important;
                                    margin-inline-end:0px;
                                    margin-inline-start:0px;
                                    margin-top:0px;'>
                        <i class="fa fa-flask" aria-hidden="true"></i> Experimental Features
                    </b-card-title>
                    <b-card-sub-title class="mb-2">
                        Enabling experimental features allows you to access new UNPACME integrations, services, and enhancements while they are still under development. 
                        By enabling these features, you could experience instability with the UNPACME application.
                    </b-card-sub-title>
                    <b-card-text>
                        <b-row style="padding-top: 10px;">
                            <b-col style="font-weight: bold" cols="2">Enable</b-col>
                            <b-col cols="9">
                                <b-form-checkbox :inline="true" :state="experimentsViewState" v-model="experimentsSwitch" @change="experimentsPrompt()" name="check-button" switch></b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-card-text>
                </b-card>
            </div>
            <div class="row" v-if="Object.keys(malpediaData).length" style="padding: 15px;">
                <b-card
                    title="Malpedia"
                    img-top
                    id="user-settings"
                    class="mb-2"
                >
                    <b-card-sub-title class="mb-2">
                        If you are an existing <a id="link" target="_blank" href="https://malpedia.caad.fkie.fraunhofer.de">Malpedia</a> user you can authorize your UnpacMe account to use the private TLP GREEN+ yara rules from Malpedia.<br> 
                        To authorize your account, log into your Malpedia account and generate a new API token. 
                        Then use your token here to authorize your account. <br> When your account is authorized matching rules will automatically be displayed in the results.
                    </b-card-sub-title>
                    <br>
                    <b-card-text>
                        <template v-if="malpediaData.malpedia_authorized">
                            <b-row style="padding-bottom: 10px;">
                                <b-col style="font-weight: bold" cols="2">Authorized</b-col>
                                <b-col cols="9"><b-badge pill variant="success">TRUE</b-badge></b-col>
                            </b-row>
                            <b-row>
                                <b-col style="font-weight: bold" cols="2">Malpedia Token</b-col>
                                <b-col cols="9">
                                    <template v-if="!malpediaLoading">
                                        {{ malpediaData.malpedia_token }}
                                    </template>
                                    <template v-else>
                                        <pulse-loader :loading="malpediaLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                    </template>
                                </b-col>
                            </b-row>
                            <br>
                            <b-button id="deactivate-malpedia" size="sm" variant="outline-danger" v-on:click="deactivateMalpedia()" ref="button">
                                Deactivate Key
                            </b-button>
                        </template>
                        <template v-else>
                            <b-row style="padding-bottom: 10px;">
                                <b-col style="font-weight: bold" cols="2">Authorized</b-col>
                                <b-col cols="9"><b-badge pill variant="danger">FALSE</b-badge></b-col>
                            </b-row>
                            <b-row>
                                <b-col style="font-weight: bold" cols="2">Malpedia Token</b-col>
                                <b-col cols="9">
                                    <template v-if="!malpediaLoading">
                                        <b-form-input v-model="inputMalpediaToken" placeholder="Enter your malpedia API token"></b-form-input>
                                    </template>
                                    <template v-else>
                                        <pulse-loader :loading="malpediaLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                    </template>
                                </b-col>
                            </b-row>
                            <br>
                            <b-button id="deactivate-malpedia" size="sm" variant="outline-success" v-on:click="authorizeMalpedia(inputMalpediaToken)" ref="button">
                                Authorize
                            </b-button>
                        </template>
                    </b-card-text>
                </b-card>
            </div>
            <div v-if="experimentsSwitch" class="row" style="padding: 15px;">
                <b-card
                    title=""
                    img-top
                    id="user-settings"
                    class="mb-2"
                >
                    <b-card-title class="mb-2" 
                                    style='color:rgb(33, 37, 41);
                                    display:block;
                                    font-family:-apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
                                    font-size:24px;
                                    font-weight:500;
                                    height:28px;
                                    line-height:28.8px;
                                    margin-block-end:12px;
                                    margin-block-start:0px;
                                    margin-bottom:12px!important;
                                    margin-inline-end:0px;
                                    margin-inline-start:0px;
                                    margin-top:0px;'>
                        <img style="height: 37px; width: 35px; padding-bottom:7px;padding-right: 5px;" src="https://analyze.intezer.com/favicon.png"/> Intezer Analyze
                    </b-card-title>
                    <b-card-sub-title class="mb-2">
                        If you are an existing <a id="link" target="_blank" href="https://analyze.intezer.com/">Intezer Analyze</a> user you can authorize your UnpacMe account to upload samples directly to Intezer Analyze for analysis. 
                        If you are not currently an Intezer Analyze user you can <a id="link" target="_blank" href="https://analyze.intezer.com/#/create-account">sign up to Intezer Analyze <i class="fa fa-external-link-square" aria-hidden="true"></i></a>
                        <br><br>
                        To authorize your account, use your Intezer Analyze API key here to enable Intezer Analyze access from your account.
                        When your account is authorized an option to upload samples to Intezer Analyze will be displayed in the results.
                    </b-card-sub-title>
                    <br>
                    <b-card-text>
                        <template v-if="intezerKey !== null">
                            <b-row style="padding-bottom: 10px;">
                                <b-col style="font-weight: bold" cols="2">Authorized</b-col>
                                <b-col cols="9"><b-badge pill variant="success">TRUE</b-badge></b-col>
                            </b-row>
                            <b-row>
                                <b-col style="font-weight: bold" cols="2">API Key</b-col>
                                <b-col cols="9">
                                    <template v-if="!intezerLoading">
                                            {{ intezerKey }}
                                    </template>
                                    <template v-else>
                                        <pulse-loader :loading="intezerLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                    </template>
                                </b-col>
                            </b-row>
                            <b-row style="padding-top: 10px;">
                                <b-col style="font-weight: bold" cols="2">Hide Results</b-col>
                                <b-col cols="9">
                                    <b-form-checkbox :inline="true" :state="hideIntezerViewState" v-model="hideIntezerSwitch" @change="hideIntezerPrompt()" name="check-button" switch></b-form-checkbox>
                                </b-col>
                            </b-row>
                            <br>
                            <b-button v-if="!intezerLoading" id="deactivate-intezer" size="sm" variant="outline-danger" v-on:click="deactivateIntezer()" ref="button">
                                Deactivate Key
                            </b-button>
                        </template>
                        <template v-else>
                            <b-row style="padding-bottom: 10px;">
                                <b-col style="font-weight: bold" cols="2">Authorized</b-col>
                                <b-col cols="9">
                                    <b-badge pill variant="danger">FALSE</b-badge>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col style="font-weight: bold" cols="2">API Key</b-col>
                                <b-col cols="9">
                                    <template v-if="!intezerLoading">
                                            <b-form-group
                                                  class="mb-0"
                                                  label-for="input-formatter"
                                                  description='For support please contact Intezer at support@intezer.com'
                                                >
                                            <b-form-input v-model="inputIntezerKey" placeholder="Enter your Intezer Analyze API Key"></b-form-input>
                                            </b-form-group>
                                    </template>
                                    <template v-else>
                                        <pulse-loader :loading="intezerLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                    </template>
                                </b-col>
                            </b-row>
                            <b-row style="padding-top: 10px;">
                                <b-col style="font-weight: bold" cols="2">Hide Results</b-col>
                                <b-col cols="9">
                                    <b-form-checkbox :inline="true" :state="hideIntezerViewState" v-model="hideIntezerSwitch" @change="hideIntezerPrompt()" name="check-button" switch></b-form-checkbox>
                                </b-col>
                            </b-row>
                            <br>
                            <b-button v-if="!intezerLoading" id="deactivate-intezer" size="sm" variant="outline-success" v-on:click="authorizeIntezer(inputIntezerKey)" ref="button">
                                Authorize
                            </b-button>
                        </template>
                    </b-card-text>
                </b-card>
            </div>
            <div class="row" style="padding: 15px;">
                <b-card
                    title="Delete Account"
                    img-top
                    id="danger-settings"
                    class="mb-2"
                >
                    <b-card-sub-title class="mb-2">
                        <div style="color: #dc3545">Delete account and cancel any associated subscriptions.</div>
                        This action is permanent. You will no longer have access to all samples and metadata associated with this account.
                    </b-card-sub-title>
                    <br>
                    <b-card-text>
                        <b-button id="delete-account" variant="outline-danger" size="sm" v-on:click="showDeleteOk=true" ref="button">
                            Delete Account
                        </b-button>
                    </b-card-text>
                </b-card>
            </div>
            <!-- ############### Models ############### -->
            <b-modal
                v-model="showDeleteOk"
                :centered="true"
                size="lg"
                header-bg-variant="light"
                header-text-variant="dark"
                :hideHeader="true"
                :hideFooter="true"
                :no-close-on-esc="true"
                :no-close-on-backdrop="true"
            >
                <b-jumbotron class="marquee" style="background-color: white; margin-bottom: 0px;">
                <template slot="header">
                    <div style="font-size: 45px;font-weight: 300;text-align: center;"><i class="fa fa-exclamation-triangle"></i> Delete Account <i class="fa fa-exclamation-triangle"></i></div>
                </template>
                <hr class="my-4">
                <br>
                <p class="popup-big">
                Your account will be deleted and any associated subscriptions canceled within the next <b>24</b> hours
                <br>
                </p>
                <br>
                <b-row>
                <b-col>
                    &nbsp;
                </b-col>
                <b-col cols="9">
                <p class="popup-small">
                You will receive a confirmation email when this process is complete.
                </p>
                </b-col>
                <b-col>
                    &nbsp;
                </b-col>
                </b-row>
                <br><br>
                <b-row>
                    <b-col>
                        &nbsp;
                    </b-col>
                    <b-col> 
                        
                        <b-btn size="md" variant="dark" @click="showDeleteOk=false" ><b style="font-size: 20px;font-weight: bold;">Cancel</b></b-btn>
                        &nbsp;&nbsp;&nbsp;
                        <b-btn size="md" variant="danger" @click="deleteAccount()" ><b style="font-size: 20px;font-weight: bold;">Delete</b></b-btn>

                    </b-col>
                    <b-col>
                        &nbsp;
                    </b-col>
                </b-row>
                </b-jumbotron>
            </b-modal>
            <b-modal
                v-model="showPaymentUpdate"
                :centered="true"
                size="lg"
                header-bg-variant="light"
                header-text-variant="dark"
                :hideHeader="true"
                :hideFooter="true"
                :no-close-on-esc="true"
                :no-close-on-backdrop="true"
            >
                <b-jumbotron class="marquee" style="background-color: white; margin-bottom: 0px;">
                <template slot="header">
                    <div style="font-size: 45px;font-weight: 300;text-align: center;">Payment Updated <i class="fa fa-check-circle"></i></div>
                </template>
                <hr class="my-4">
                <br>
                <p class="popup-big">
                Your payment information has been successfully updated!
                <br>
                </p>
                <br>
                <b-row>
                <b-col>
                    &nbsp;
                </b-col>
                <b-col cols="9">
                <p class="popup-small">
                You will also receive an email for your records.
                </p>
                </b-col>
                <b-col>
                    &nbsp;
                </b-col>
                </b-row>
                <br><br>
                <div style="text-align: center;"><b-btn variant="success" href="/account" ><b style="font-size: 20px;font-weight: bold;">OK</b></b-btn></div>
                </b-jumbotron>
            </b-modal>
            <b-modal
                v-model="showPlanCancel"
                :centered="true"
                size="lg"
                header-bg-variant="light"
                header-text-variant="dark"
                :hideHeader="true"
                :hideFooter="true"
                :no-close-on-esc="true"
                :no-close-on-backdrop="true"
            >
                <b-jumbotron class="marquee" style="background-color: white; margin-bottom: 0px;">
                <template slot="header">
                    <div style="font-size: 45px;font-weight: 300;text-align: center;">Plan Canceled <i class="fa fa-check-circle"></i></div>
                </template>
                <hr class="my-4">
                <br>
                <p class="popup-big">
                Your plan has been successfully canceled!
                <br>
                </p>
                <br>
                <b-row>
                <b-col>
                    &nbsp;
                </b-col>
                <b-col cols="9">
                <p class="popup-small">
                You will also receive an email for your records.
                </p>
                </b-col>
                <b-col>
                    &nbsp;
                </b-col>
                </b-row>
                <br><br>
                <div style="text-align: center;"><b-btn variant="success" href="/account" ><b style="font-size: 20px;font-weight: bold;">OK</b></b-btn></div>
                </b-jumbotron>
            </b-modal>
        </template>
    </b-container>
</template>

<script>
import axios from 'axios';

export default {
    props: ['auth'],
    beforeCreate() {
        document.body.className = 'none';
    },
    data() {
        if (this.auth.userProfile) {
            this.$nextTick(() => {
                this.profile = this.auth.userProfile;
            });
        } else {
            this.auth.getProfile((err, profile) => {
                if (err) return console.log(err);
                this.profile = profile;
                return null;
            });
        }
        return {
            profile: {},
            accessData: {},
            malpediaData: {},
            intezerKey: null,
            inputMalpediaToken: "",
            inputIntezerKey: "",
            showDeleteOk: false,
            showPaymentUpdate: false,
            showPlanCancel: false,
            stripe: Stripe('pk_live_x1VEyNjpOupNBT7BGcEjCpJM005YveHCLX'),
            malpediaLoading: false,
            intezerLoading: false,
            cancelPlanLoading: false,
            changePaymentLoading: false,
            hideIntezerSwitch: false,
            experimentsSwitch: false,
        };
    },
    metaInfo() {
        return {
            title: 'UnpacMe Account',
            meta: [{ name: 'description', content: 'UnpacMe is an automated malware unpacking service. We provide malware analysis at Internet scale. Free for non-commercial use.' },
                { name: 'keywords', content: 'unpacking,unpacme,unpakme,unpackme,malware,malware analysis,analysis,automation,sandbox,oalabs,openanalysis,open analysis' }],
        };
    },
    computed: {
        hideIntezerViewState() {
            if (this.hideIntezerSwitch) {
                return false
            }
            else {
                return null
            }
        
        },
        experimentsViewState() {
            if (this.experimentsSwitch) {
                return true
            }
            else {
                return null
            }
        
        }
    },
    notifications: {
        showErrorMsg: {
            type: 'error',
            title: 'ERROR',
            message: 'That\'s the error',
            timeout: 30000,
        },
    },
    methods: {
        getAccessData() {
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/user/access';
            axios.get(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    //console.log(res.data);
                    this.accessData = res.data;
                })
                .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
                });
        },
        deleteAccount() {
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/contact/delete/account';
            axios.get(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    //console.log(res.data);
                    //this.showDeleteOk = true;
                    this.auth.logout()
                    console.log("logging out");
                })
                .catch((error) => {
                    // eslint-disable-next-line
                    console.error(error);
                    //TODO: raise error alert
                    this.showErrorMsg({ title: 'Delete Failed', message: '<br>Our account services are currently offline. Please try again later, or email us directly at <a style="color:white;font-weight:bold;" href="mailto:unpacme@openanalysis.net">unpacme@openanalysis.net</a>' });
                });
        },
        experimentsPrompt() {
            if (this.experimentsSwitch) {
                localStorage.setItem('experiments', 'false');
            }
            else {
                localStorage.setItem('experiments', 'true');
            }
        },
        getExperimentsPromptStatus() {
            // Get Intezer status
            if (localStorage.hasOwnProperty("experiments") && localStorage.getItem('experiments') === 'true') {
                console.log("experiments enabled");
                this.experimentsSwitch = true;
            }

        },
        hideIntezerPrompt() {
            if (this.hideIntezerSwitch) {
                localStorage.setItem('hide_intezer', 'false');
            }
            else {
                localStorage.setItem('hide_intezer', 'true');
            }
        },
        getIntezerPromptStatus() {
            // Get Intezer status
            if (localStorage.hasOwnProperty("hide_intezer") && localStorage.getItem('hide_intezer') === 'true') {
                console.log("hide intezer");
                this.hideIntezerSwitch = true;
            }

        },
        getIntezerData() {
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/user/intezer';
            axios.get(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    //console.log(res.data);
                    this.intezerKey = res.data.intezer_key;
                })
                .catch((error) => {
                    // eslint-disable-next-line
                    console.error(error);
                });
        },
        deactivateIntezer() {
            this.intezerLoading = true;
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/user/intezer';
            axios.delete(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    //console.log(res.data);
                    this.intezerKey = res.data.intezer_key;
                    this.intezerLoading = false;
                })
                .catch((error) => {
                    this.showErrorMsg({ title: 'Deactivate Failed', message: '<br>Request failed please try again.' });
                    // eslint-disable-next-line
                    console.error(error);
                    this.intezerLoading = false;
                });
        },
        authorizeIntezer(inputIntezerKey) {
            this.intezerLoading = true;
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/user/intezer';
            const data = {
                'key': inputIntezerKey.trim()
            }
            axios.post(path, data, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    //console.log(res.data);
                    this.intezerKey = res.data.intezer_key;
                    this.intezerLoading = false;
                })
                .catch((error) => {
                    const message = error.response.data;
                    if (message !== undefined && message !== null && message.constructor === Object) {
                        // msg is json so check if there is a description for us
                        if (Object.prototype.hasOwnProperty.call(message, 'description')) {
                            this.showErrorMsg({ title: 'Authorization Failed', message: `</br>${message.description.split('. ').join('</br>')}` });
                        } else {
                            this.showErrorMsg({ title: 'Authorization Failed', message: '</br>Generic error.' });
                        }
                    } else if (message !== undefined && message !== null && message.constructor === String) {
                        // msg is string so just print it as the error
                        this.showErrorMsg({ title: 'Authorization Failed', message: `</br>${message.split('. ').join('</br>')}` });
                    } else {
                        this.showErrorMsg({ title: 'Authorization Failed', message: '</br>Generic error.' });
                    }
                    //this.showErrorMsg({ title: 'Authorization failed', message: 'Request failed please try again.' });
                    // eslint-disable-next-line
                    console.error(error.response.data);
                    this.intezerLoading = false;
                });
        },
        getMalpediaData() {
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/user/malpedia';
            axios.get(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    //console.log(res.data);
                    this.malpediaData = res.data;
                })
                .catch((error) => {
                    // eslint-disable-next-line
                    console.error(error);
                });
        },
        deactivateMalpedia() {
            this.malpediaLoading = true;
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/user/malpedia';
            axios.delete(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    //console.log(res.data);
                    this.malpediaData = res.data;
                    this.malpediaLoading = false;
                })
                .catch((error) => {
                    this.showErrorMsg({ title: 'Deactivate Failed', message: '<br>Request failed please try again.' });
                    // eslint-disable-next-line
                    console.error(error);
                    this.malpediaLoading = false;
                });
        },
        authorizeMalpedia(inputMalpediaToken) {
            this.malpediaLoading = true;
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/user/malpedia';
            const data = {
                'token': inputMalpediaToken.trim()
            }
            axios.post(path, data, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    //console.log(res.data);
                    this.malpediaData = res.data;
                    this.malpediaLoading = false;
                })
                .catch((error) => {
                    const message = error.response.data;
                    if (message !== undefined && message !== null && message.constructor === Object) {
                        // msg is json so check if there is a description for us
                        if (Object.prototype.hasOwnProperty.call(message, 'description')) {
                            this.showErrorMsg({ title: 'Authorization Failed', message: `</br>${message.description.split('. ').join('</br>')}` });
                        } else {
                            this.showErrorMsg({ title: 'Authorization Failed', message: '</br>Generic error.' });
                        }
                    } else if (message !== undefined && message !== null && message.constructor === String) {
                        // msg is string so just print it as the error
                        this.showErrorMsg({ title: 'Authorization Failed', message: `</br>${message.split('. ').join('</br>')}` });
                    } else {
                        this.showErrorMsg({ title: 'Authorization Failed', message: '</br>Generic error.' });
                    }
                    //this.showErrorMsg({ title: 'Authorization failed', message: 'Request failed please try again.' });
                    // eslint-disable-next-line
                    console.error(error.response.data);
                    this.malpediaLoading = false;
                });
        },
        changePayment() {
            const tempBearer = this.getAuthBearer();
            this.changePaymentPath = "";
            if (this.accessData.roles.includes("researcher")) {
                this.changePaymentPath = 'https://api.unpac.me/api/v1/private/account/renew/researcher'
            }
            else if (this.accessData.roles.includes("pro")) {
                this.changePaymentPath = 'https://api.unpac.me/api/v1/private/account/renew/pro'
            }
            else {
                this.showErrorMsg({ title: 'Invalid Request', message: '<br>Payment information cannot be updated for your account.' });
                return;
            }
            this.changePaymentLoading = true;
            axios.get(this.changePaymentPath, { headers: { Authorization: tempBearer } })
                .then((res) => {
                        this.changePaymentLoading = false;
                        this.stripe.redirectToCheckout({
                            sessionId: res.data.session_id
                    }).then(function (result) {
                        this.changePaymentLoading = false;
                        this.showErrorMsg({ title: 'Request Failed', message: '<br>Our account services are currently offline. Please try again later, or email us directly at <a style="color:white;font-weight:bold;" href="mailto:unpacme@openanalysis.net">unpacme@openanalysis.net</a>' });
                    });
                })
                .catch((error) => {
                    this.changePaymentLoading = false;
                    this.showErrorMsg({ title: 'Request Failed', message: '<br>Our account services are currently offline. Please try again later, or email us directly at <a style="color:white;font-weight:bold;" href="mailto:unpacme@openanalysis.net">unpacme@openanalysis.net</a>' });
                });
        },
        cancelPlan() {
            const tempBearer = this.getAuthBearer();
            this.cancelPath="";
            if (this.accessData.roles.includes("researcher")) {
                this.cancelPath = 'https://api.unpac.me/api/v1/private/account/cancel/researcher'
            }
            else if (this.accessData.roles.includes("pro")) {
                this.cancelPath = 'https://api.unpac.me/api/v1/private/account/cancel/pro'
            }
            else {
                this.showErrorMsg({ title: 'Invalid Request', message: '<br>Cannot cancel unknown account.' });
                return;
            }
            this.cancelPlanLoading = true;
            axios.get(this.cancelPath, { headers: { Authorization: tempBearer } })
                .then((res) => {
                   this.showPlanCancel = true;
                   this.cancelPlanLoading = false;
                })
                .catch((error) => {
                    this.showErrorMsg({ title: 'Request Failed', message: '<br>Our account services are currently offline. Please try again later, or email us directly at <a style="color:white;font-weight:bold;" href="mailto:unpacme@openanalysis.net">unpacme@openanalysis.net</a>' });
                    this.cancelPlanLoading = false;
                });
        },
        getAuthBearer() {
            this.accessToken = localStorage.getItem('access_token') || null;
            return `Bearer ${this.accessToken}`;
        },
    },
    created() {
        if ( this.$route.query.status === "paymentupdated") {
            this.showPaymentUpdate = true;
        }
        this.getAccessData();
        this.getExperimentsPromptStatus();
        this.getMalpediaData();
        this.getIntezerData();
        this.getIntezerPromptStatus();
    },
};
</script>

<style>
  .profile-area img {
    max-width: 150px;
    margin-bottom: 20px;
  }

  .panel-body h3 {
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Account.vue